<template>
  <div class="content component-users">
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item">
        <a href="javascript:;">Home</a>
      </li>
      <li class="breadcrumb-item active">{{ $t('users.subtitle') }}</li>
    </ol>
    <h1 class="page-header">
      {{ $t('app.name') }}
      <small>{{ $t('users.subtitle') }}</small>
    </h1>

    <b-row>
      <b-col cols="12">
        <ct-user-widget/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CtUserWidget from '@/components/Users/UsersWidget.vue';

export default {
  name: 'Users',
  components: {
    CtUserWidget,
  },
};
</script>

<style scoped lang="scss">
@media print {
  .content {
    margin-left: 0;
  }
  .breadcrumb {
    display: none;
  }
  .page-header {
    display: none;
  }
}
</style>
